const gamePlayedReducer = (state=false,action)=>{
    switch(action.type){
        case "GAMEPLAYED":
            return true;
        case "GAMEUNPLAYED":
            return false;
        default:
            return state;
    }
}

export default gamePlayedReducer;